import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SideMenu.css';
import {
  Button,
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from 'react-bootstrap';
import cx from 'classnames';
import FontAwesome from 'react-icons/fa';

// Locale
import messages from '../../../locale/messages';

// Component
import Link from '../../Link';
import history from '../../../core/history';
import { Text } from '../../../components_new/common';

class SideMenu extends React.Component {
  static propTypes = {};

  handleClick() {
    history.push('/add-listing');
  }

  render() {
    return (
      <Col xs={12} sm={3} md={3} lg={3} className={s.smPadding}>
        <ul className={s.listContainer}>
          <li>
            <Link
              to={'/reservation/current'}
              className="block px-6 t-l primary helvetica"
            >
              <Text link large>
                <FormattedMessage {...messages.upcomingReservations} />
              </Text>
            </Link>
          </li>
          <li>
            <Link
              to={'/reservation/previous'}
              className="block px-6 t-l primary helvetica"
            >
              <Text link large>
                <FormattedMessage {...messages.previousReservations} />
              </Text>
            </Link>
          </li>
        </ul>
      </Col>
    );
  }
}

export default withStyles(s)(SideMenu);



// WEBPACK FOOTER //
// ./src/components/ManageListing/SideMenu/SideMenu.js